export default "__VITE_ASSET__878b7590__"